// TODO: hook into potential logging service

export class Log {
    public static message(obj:any, extraObj?:any){
        if(!extraObj) {
            //console.log(obj);
        } else {
            //console.log(obj, extraObj);
        }
    }
    public static warning(obj:any, extraObj?:any){
        if(!extraObj) {
            //console.warn(obj);
        } else {
            //console.warn(obj, extraObj);
        }
    }
    public static error(obj:any, extraObj?:any){
        if(!extraObj) {
            //console.error(obj);
        } else {
            //console.error(obj, extraObj);
        }
    }
}